module.exports = __webpack_public_path__ + "img/logo.3aae610b.png";